import { events } from "@planzone/events";
import { Boundaries } from "@planzone/core";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { State, Selector } from "./types";
import { initialState } from "./initialState";
import { createSelector } from "./selector";

function handleRequest(
  state: State,
  { elementId }: Boundaries["attachDocumentsToElement"]["request"],
): State {
  const index = state.findIndex((req) => req.elementId === elementId);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { ...state[index], request: setRequestStateToPending() },
        ...state.slice(index + 1),
      ]
    : [...state, { elementId, request: setRequestStateToPending() }];
}

function handleSuccess(
  state: State,
  { elementId }: Boundaries["attachDocumentsToElement"]["success"],
): State {
  const index = state.findIndex((req) => req.elementId === elementId);

  return index !== -1
    ? [
        ...state.slice(0, index),
        { elementId, request: setRequestStateToSuccess() },
        ...state.slice(index + 1),
      ]
    : [...state, { elementId, request: setRequestStateToSuccess() }];
}

function handleFailure(
  state: State,
  { elementId }: Boundaries["attachDocumentsToElement"]["failure"],
): State {
  const index = state.findIndex((req) => req.elementId === elementId);

  return index !== -1
    ? [
        ...state.slice(0, index),
        {
          ...state[index],
          request: setRequestStateToFailure(),
        },
        ...state.slice(index + 1),
      ]
    : [...state, { elementId, request: setRequestStateToFailure() }];
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.attachDocumentsToElementRequested]: handleRequest,
    [events.attachDocumentsToElementSucceeded]: handleSuccess,
    [events.attachDocumentsToElementFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
